import React, { useMemo } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { uniqueId } from 'js/utils/methods.util';
import style from './index.scss';

export default function Select(props) {
    const {
        options = [],
        label = '',
        placeholder = '',
        className = '',
        onChange = () => {},
        ...rest
    } = props;
    const id = uniqueId('select-');
    const translate = useTranslations();

    const selectClassName = useMemo(() => [
        className,
        style.select,
        placeholder && (rest.value == null || rest.value === '') ? style.empty : ''
    ].filter(Boolean).join(' '), [placeholder, className, rest.value]);

    return (
        <span className={style.wrapper}>
            {label && <label className={style.label} htmlFor={id}>{label}</label>}
            <select className={selectClassName}
                id ={id}
                onChange={onChange}
                aria-label={label || placeholder || translate('playtech.mobile.system.select.aria-label')}
                {...rest}>
                {placeholder && <option disabled value="" className="hidden">{placeholder}</option>}
                {options.map(item => (
                    <option key={item.value}
                        value={item.value}
                        className={style.option}>{item.label || item.value}
                    </option>
                ))}
            </select>
            <div className={style.border}></div>
        </span>
    );
}
